// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__CfnUf","skeletonRunner":"skeleton_skeletonRunner__4AlNY"};